import { EXTERNAL_COLLECTION_NOTICE_STATUS_BILLED } from '@core/constants';
import { CollectionNoticeModel } from '@core/models';

export function getExternalCollectionNoticeStatus(
  collectionNotice: CollectionNoticeModel
): string {
  if (
    collectionNotice.status.toLowerCase() === 'pagado' &&
    collectionNotice.invoiceId
  ) {
    return EXTERNAL_COLLECTION_NOTICE_STATUS_BILLED;
  }
  return collectionNotice.status;
}
